export default "__VITE_ASSET__B2rHTh3K__"